import { getAppApiRoutes } from "../../Global";
import {
  TerminalFilterRequestModel,
  TerminalRelocationRequestModel,
  TerminalTakeBackRequestModel,
  TerminalUpdateRequestModel,
} from "../../models/RequestModels";
import ResponseModel from "../../models/ResponseModel";
import { apiPost, apiPut } from "../apiClient";

class TerminalService {
  async getTerminals(filter: TerminalFilterRequestModel = {}): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.terminal.getTerminals, { filter });
  }

  async updateTerminal(id: number, data: TerminalUpdateRequestModel = {}): Promise<ResponseModel> {
    return apiPut(getAppApiRoutes.terminal.updateTerminal.replace("{id}", id.toString()), data);
  }

  async terminalTakeBack(id: number, data: TerminalTakeBackRequestModel): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.terminal.terminalTakeBack.replace("{id}", id.toString()), data);
  }

  async terminalRelocation(id: number, data: TerminalRelocationRequestModel): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.terminal.terminalRelocation.replace("{id}", id.toString()), data);
  }
}

const service: TerminalService = new TerminalService();
export default service;
